module.exports = __webpack_public_path__ + "static/media/popular3x.0bd04a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/popular3x.png
// module id = 2059
// module chunks = 6